import { render, staticRenderFns } from "./CollapseTitle.vue?vue&type=template&id=f8d4be36&scoped=true&"
import script from "./CollapseTitle.vue?vue&type=script&lang=js&"
export * from "./CollapseTitle.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTitle.vue?vue&type=style&index=0&id=f8d4be36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d4be36",
  null
  
)

export default component.exports